if (!MediaTextSlider) {
  var MediaTextSlider = class extends HTMLElement {
    constructor() {
      super();

      this.slider = this.querySelector('.media-text-slider');
      this.loadSlider(this.slider);
    }

    loadSlider(slider) {
      const parent = slider.parentElement;
      const prevEl = parent.querySelector('.swiper-button-prev');
      const nextEl = parent.querySelector('.swiper-button-next');

      const mediaTextSlider = new Swiper('.media-text-slider', {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        allowTouchMove: true,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        breakpoints: {
          768: {
            allowTouchMove: false,
          }
        }
      });
    }
  }

  customElements.define('media-text-slider', MediaTextSlider);
}